import { FC, Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import styled from 'styled-components';
import { CustomErrorBoundary } from 'src/components/widgets/customErrorBoundary';
import { Dialog } from 'src/components/widgets/dialog';
import Loader from 'src/components/widgets/loader';
import { T } from 'src/shared/helpers';
import { presetConfigurationsQueriesiFrameUrlQuery } from './__generated__/presetConfigurationsQueriesiFrameUrlQuery.graphql';
import { iFrameUrlQuery } from './presetConfigurationsQueries';

const EditorFrame = styled.iframe`
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
`;

const EditorContent: FC<{ modelID: number; templateID?: number }> = ({ modelID, templateID }) => {
    const data = useLazyLoadQuery<presetConfigurationsQueriesiFrameUrlQuery>(
        iFrameUrlQuery,
        { input: { modelID, templateID: templateID ?? null } },
        { fetchPolicy: 'network-only' }
    );
    if (!data.preSetPreviewUrl) throw new Error(T._('It was not possible to open the pre-set configuration editor.', 'Admin'));
    return <EditorFrame title={T._('Pre-set configuration editor', 'Admin')} src={data.preSetPreviewUrl} allowFullScreen />;
};

const PresetConfigurationEditorDialog: FC<{ modelID: number; templateID?: number; onClose: () => void }> = (props) => (
    <Dialog size='fullscreen' onClose={props.onClose} buttons={[{ label: T._('Close editor', 'Admin'), outline: true, onClick: props.onClose }]}>
        <CustomErrorBoundary render={(error) => <p role='alert'>{error?.message}</p>}>
            <Suspense fallback={<Loader />}>
                <EditorContent modelID={props.modelID} templateID={props.templateID} />
            </Suspense>
        </CustomErrorBoundary>
    </Dialog>
);

export default PresetConfigurationEditorDialog;
